import React from 'react';

import { formatDate } from 'utils';
import { useAggregatedHoldingsReport } from 'views/portfolio/reporting-queries';

import { useReportingScope } from '../reporting/useReportingScope';
import { AssetAllocation } from './components/AssetAllocation';
import { HoldingsBreakdownTable } from './components/HoldingsBreakdownTable';
import { HoldingsHero } from './components/HoldingsHero';

// The Holdings section of the reporting overview: the as-of line, the holdings KPIs, the
// allocation bar and the per-asset-class breakdown. Reads its scope from the URL like the other
// sections.
export const HoldingsSection = () => {
    // Holdings ignore the scope's date range: the report is a latest-EOD snapshot.
    const { householdGUID, selectedAccountGUIDs, includeClosed } = useReportingScope();
    const { data: report, isPending } = useAggregatedHoldingsReport({
        householdGUID,
        groupByGuids: selectedAccountGUIDs,
        includeClosed,
    });

    // formatDate returns '' until the snapshot date is known, leaving a bare "As of EOD".
    const snapshotDate = formatDate(report?.sourceReportDate, 'HUMAN');
    const asOf = snapshotDate ? `As of EOD ${snapshotDate}` : 'As of EOD';

    return (
        <>
            <div className="text-cocoa-500 text-sm">{asOf}</div>
            <HoldingsHero report={report} isLoading={isPending} />
            <AssetAllocation report={report} isLoading={isPending} />
            <HoldingsBreakdownTable report={report} isLoading={isPending} asOf={asOf} />
        </>
    );
};
